"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = CheckmarkCircle;

var _CheckmarkCircle = require("@adobe/react-spectrum-workflow/dist/CheckmarkCircle");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function CheckmarkCircle(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_CheckmarkCircle.A4uCheckmarkCircle, null));
}